module.exports = __webpack_public_path__ + "img/img-ffp-west@2x.91412d5a.jpg";